import { CurrentSubscriptionStatus } from "@gymflow/types";
import { Status, StatusColorType } from "apps/portal/src/components/atoms";
import { ReactNode } from "react";
import { Trans } from "react-i18next";

type HostedPagesProfileStatusProps = {
  status: CurrentSubscriptionStatus;
};

const STATUS_MAP: Record<
  CurrentSubscriptionStatus,
  { color: StatusColorType; text: ReactNode }
> = {
  ACTIVE: {
    color: "success",
    text: (
      <Trans i18nKey="pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.hostedPagesProfileStatus.status.active" />
    ),
  },
  PENDING: {
    color: "lightblue",
    text: (
      <Trans i18nKey="pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.hostedPagesProfileStatus.status.pending" />
    ),
  },
  ACTIVE_CHANGING: {
    color: "success",
    text: (
      <Trans i18nKey="pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.hostedPagesProfileStatus.status.active" />
    ),
  },
  ACTIVE_PAUSING: {
    color: "success",
    text: (
      <Trans i18nKey="pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.hostedPagesProfileStatus.status.active" />
    ),
  },
  ACTIVE_CANCELLING: {
    color: "success",
    text: (
      <Trans i18nKey="pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.hostedPagesProfileStatus.status.active" />
    ),
  },
  PAUSED: {
    color: "warning",
    text: (
      <Trans i18nKey="pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.hostedPagesProfileStatus.status.paused" />
    ),
  },
  OVERDUE_AUTH_NEEDED: {
    color: "error",
    text: (
      <Trans i18nKey="pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.hostedPagesProfileStatus.status.overdue" />
    ),
  },
  OVERDUE_PAYMENT: {
    color: "error",
    text: (
      <Trans i18nKey="pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.hostedPagesProfileStatus.status.overdue" />
    ),
  },
};

export const HostedPagesProfileStatus = ({
  status,
}: HostedPagesProfileStatusProps) => {
  const { color, text } = STATUS_MAP[status];

  return <Status text={text} statusColor={color} />;
};
